import { ReactNode } from 'react';
import c from 'classnames';
import { useTriggerFormContext } from '../../../integrations/lavva/modules/trigger-form/context';
import './index.scss';

type ConditionListItemProps = {
  icon: ReactNode;
  title: string;
  content: string;
  onClick: () => void;
  className?: string;
  noBackgroundIcon?: boolean;
  disabled?: boolean;
};

const ConditionListItem: React.FC<ConditionListItemProps> = ({
  title,
  icon,
  content,
  onClick,
  className,
  noBackgroundIcon,
  disabled,
}) => {
  const { removeTimeCondition, removePriceCondition } = useTriggerFormContext();

  const handleClick = () => {
    removeTimeCondition();
    removePriceCondition();

    onClick();
  };

  return (
    <button key={title} className={c('condition-list__box', className)} disabled={disabled} onClick={handleClick}>
      <div className={c('condition-list__box-icon', { 'no-background': noBackgroundIcon })}>{icon}</div>
      <div className="condition-list__box-wrapper">
        <div className="condition-list__box-title">{title}</div>
        <div className="condition-list__box-content">{content}</div>
      </div>
    </button>
  );
};

export default ConditionListItem;
